import React, { useState } from 'react';
import menuData from './menuData.json';
import logo from './assets/logo.png';
import './Menu.css';

const Menu = () => {
    const [page, setPage] = useState(0);

    const renderSection = (title) => (
        <div className="menu-section">
            <h2 className="menu-title">{title}</h2>
            <ul className="menu-list">
                {menuData[title]?.map((item, idx) => (
                    <li key={idx} className="menu-item">
                        <span>{item.name}</span>
                        <span>{item.price || "-"}</span>
                    </li>
                ))}
            </ul>
        </div>
    );

    return (
        <div className="menu-bg">
            <div className="menu-container">
                <div className="menu-header">
                    <img src={logo} alt="Hotspot Logo" className="menu-logo-img" />
                </div>

                {page === 0 && (
                    <div className="legend-page">
                        <h1 className="legend-title">Welcome to Hotspot</h1>
                        <p className="legend-desc">Discover our delicious selection of drinks, smoothies, food, and desserts. Please choose a menu section to begin:</p>
                        <div className="legend-buttons">
                            <button className="legend-btn" onClick={() => setPage(1)}>
                                Drinks & Smoothies
                            </button>
                            <button className="legend-btn" onClick={() => setPage(2)}>
                                Food & Desserts
                            </button>
                        </div>
                    </div>
                )}

                {page === 1 && (
                    <>
                        <div className="menu-main">
                            {renderSection("Hot Beverages")}
                            {renderSection("Iced Drinks")}
                        </div>
                        <div className="menu-main">
                            {renderSection("Cold Beverages")}
                            {renderSection("Milkshakes")}
                        </div>
                        <div className="menu-main menu-main-bottom">
                            {renderSection("Smoothies")}
                        </div>
                    </>
                )}

                {page === 2 && (
                    <>
                        <div className="menu-main">
                            {renderSection("Desserts")}
                            {renderSection("Salads")}
                        </div>
                        <div className="menu-main menu-main-bottom">
                            {renderSection("Sandwiches")}
                            {renderSection("Add-ons")}
                        </div>
                    </>
                )}

                <div className="menu-navigation">
                    {page > 0 && <button onClick={() => setPage(0)}>← Back to Legend</button>}
                    {page === 1 && <button onClick={() => setPage(2)}>Next →</button>}
                    {page === 2 && <button onClick={() => setPage(1)}>← Back</button>}
                </div>
            </div>
        </div>
    );
};

export default Menu;
